export default [
  {
    path: '/faceRecognition',
    component: () => import('@/views/FaceRecognition'),
    meta: { requireAuth: true }
  }
]
